module.exports = __webpack_public_path__ + "static/media/reports.c7041cf4.svg";